import React from "react";

const NotAuthorised = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        textAlign: "center",
        width: "100%",
        alignItems: "center",
        height: "100vh",
      }}
    >
      <h1>
        You are not authorised to access this page!! Redirect to{" "}
        <a href="form">Home</a>
      </h1>
    </div>
  );
};

export default NotAuthorised;
